// extracted by mini-css-extract-plugin
export default {"container":"sdPH5dMrntlGYTZojQgM","titleBlock":"z2dPDrndl6puLycWNGlV","title":"UnyoYsNyLX5j2a8CWwKR","controls":"JXr8jLER0VxTCvZkcdz_","playPauseButton":"VlVE58kw0ToqHa58u5j0"};